import React from 'react'
import { useRTL } from '../../contexts/RTLContext'

// Disclaimer text for different languages
const DISCLAIMER_TEXT_EN = 
  "AI responses may contain inaccuracies or errors. Please verify important information independently."

const DISCLAIMER_TEXT_HE = 
  "תגובות הבינה המלאכותית עלולות להכיל אי דיוקים או שגיאות. אנא בדקו מידע חשוב באופן עצמאי."

const DISCLAIMER_TEXT_AR = 
  "قد تحتوي استجابات الذكاء الاصطناعي على معلومات غير دقيقة أو أخطاء. يرجى التحقق من المعلومات المهمة بشكل مستقل."

export function AIDisclaimer() {
  const { language, isRTL } = useRTL()

  // Get appropriate disclaimer text based on language
  const getDisclaimerText = () => {
    switch (language) {
      case 'heb':
        return DISCLAIMER_TEXT_HE
      case 'arb':
        return DISCLAIMER_TEXT_AR
      default:
        return DISCLAIMER_TEXT_EN
    }
  }

  const disclaimerText = getDisclaimerText()

  return (
    <div className="w-full max-w-3xl px-4 pt-2 pb-0">
      <p 
        className="text-xs text-gray-500 leading-relaxed text-center"
        style={{
          direction: isRTL ? 'rtl' : 'ltr'
        }}
        dir={isRTL ? 'rtl' : 'ltr'}
      >
        {disclaimerText}
      </p>
    </div>
  )
}
